import 'react-native-url-polyfill/auto'
import { useTranslations } from '@aikoa/i18n/react'
import { useRouter } from 'expo-router'
import { useEffect } from 'react'
import { View } from 'react-native'
import { appHeaderState$ } from '~/components/AppHeader'
import Auth from '~/components/Auth'
import { useAppView } from '~/components/layout/AppViewContext'
import ContentBox from '~/components/layout/ContentBox'
import ScreenView from '~/components/layout/ScreenView'
import { SectionContent } from '~/components/layout/Sections'
import { Body } from '~/components/typography/Content'
import { Heading2 } from '~/components/typography/Titles'
import { LinkButton } from '~/components/ui/button'
import { Text } from '~/components/ui/text'
import { PolicyLinks } from '~/components/user/PolicyLinks'

export default function Login() {
  const { t } = useTranslations('common')
  const { setBackgroundTheme } = useAppView()

  useEffect(() => {
    setBackgroundTheme(0)
  }, [setBackgroundTheme])

  useEffect(() => {
    appHeaderState$.restrictedStates.set(() => new Set(['menu', 'onboarding', 'login']))

    return () => {
      appHeaderState$.restrictedStates.clear()
    }
  }, [])

  const router = useRouter()

  return (
    <ScreenView>
      <ContentBox
        className="flex-1 justify-center"
        contentContainerClassName="gap-8"
        variant="transparent">
        <Auth
          onAuthenticated={() => {
            router.replace('/(authenticated)')
          }}
          inputVariant="box"
          className="mx-auto w-full"
          allowAccountCreation={false}
          content={
            <View className="gap-2">
              <Heading2 className="text-center">{t(($) => $.login.title)}</Heading2>
              <SectionContent>{t(($) => $.login.description)}</SectionContent>
            </View>
          }
        />
        <View className="gap-3 border-t border-border pt-6">
          <Heading2 className="text-center">{t(($) => $.login.newUserTitle)}</Heading2>
          <Body className="mb-2 text-pretty text-center text-lg/normal">
            <Text>
              {t(($) => $.login.pilotDescription.before)}
              <Text className="font-semibold">{t(($) => $.login.pilotDescription.pilot)}</Text>
              {t(($) => $.login.pilotDescription.after)}
            </Text>
          </Body>
          {/* eslint-disable-next-line i18next/no-literal-string */}
          <LinkButton variant="primary" size="lg" href="mailto:info@aikoa.fi">
            info@aikoa.fi
          </LinkButton>
        </View>
      </ContentBox>
      <PolicyLinks />
    </ScreenView>
  )
}
